export default function (namespace) {
    jQuery(window).off('resize.' + namespace);
}